import { AgentField } from './types';

export function getAllAgentFields(): AgentField[] {
  return Object.values(AgentField);
}
